<div class="modalError">
    <div>
      <h4 class="titleModal">{{title}}</h4>
    </div>
    @if (errorDetails) {
      @if (hasToggle) {
        <mat-expansion-panel >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{errorDetails.customText}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>{{errorDetails.customDetails}}</p>
        </mat-expansion-panel>
      } @else {
        <p class="errorText">{{errorDetails.customText}}</p>
      }
    }

    <div class="my-button-container">
      <button class="my-button back" mat-raised-button (click)="close()">{{closeLabel}}</button>
    </div>
</div>
